// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.health-status {
  position: relative;
  display: inline-flex;
}

.health-status__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid var(--color-theme-toggle-border);
  border-radius: 999px;
  background: var(--color-theme-toggle-bg);
  color: var(--color-theme-toggle-icon);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.health-status__trigger svg,
.health-status__trigger .app-icon {
  width: 18px;
  height: 18px;
  color: inherit;
}

.health-status__trigger:hover,
.health-status__trigger--open {
  background: var(--color-theme-toggle-hover);
  color: var(--color-text);
}

.health-status__popup {
  position: absolute;
  top: calc(100% + 0.55rem);
  right: 0;
  z-index: 20;
  width: min(360px, calc(100vw - 1.5rem));
  max-width: calc(100vw - 1.5rem);
  padding: 0.85rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
}

@media (max-width: 640px) {
  .health-status__popup {
    position: fixed;
    top: calc(0.65rem + 42px + 0.45rem + env(safe-area-inset-top, 0px));
    right: max(0.65rem, env(safe-area-inset-right, 0px));
    left: max(0.65rem, env(safe-area-inset-left, 0px));
    width: auto;
    max-width: none;
  }
}

.health-status__popup-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
}

.health-status__popup-header strong {
  display: block;
  font-size: 0.88rem;
}

.health-status__popup-header span {
  display: block;
  margin-top: 0.1rem;
  color: var(--color-text-muted);
  font-size: 0.72rem;
}

.health-status__refresh {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 999px;
  background: var(--color-btn);
  color: var(--color-btn-text);
  cursor: pointer;
  transition: filter 0.2s ease, background 0.2s ease;
}

.health-status__refresh:hover:not(:disabled) {
  filter: brightness(1.08);
}

[data-theme='dark'] .health-status__refresh {
  background: #ffffff;
  color: #1a2332;
}

[data-theme='dark'] .health-status__refresh:hover:not(:disabled) {
  filter: brightness(0.96);
}

.health-status__refresh:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.health-status__refresh svg,
.health-status__refresh .app-icon {
  width: 16px;
  height: 16px;
  color: inherit;
}

.health-status__json {
  margin: 0;
  max-height: 280px;
  padding: 0.85rem;
  overflow: auto;
  border: 1px solid var(--color-border);
  border-radius: calc(var(--radius) - 2px);
  background: var(--color-surface);
  color: var(--color-text);
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
    'Courier New', monospace;
  font-size: 0.78rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.health-status__json--error {
  border-color: color-mix(in srgb, #b42318 40%, var(--color-border));
}
`, "",{"version":3,"sources":["webpack://./src/components/HealthStatusButton.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kDAAkD;EAClD,oBAAoB;EACpB,wCAAwC;EACxC,qCAAqC;EACrC,eAAe;EACf,yEAAyE;AAC3E;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;EAEE,2CAA2C;EAC3C,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,WAAW;EACX,uCAAuC;EACvC,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;IACf,mEAAmE;IACnE,oDAAoD;IACpD,kDAAkD;IAClD,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,4BAA4B;EAC5B,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,wCAAwC;EACxC,gCAAgC;EAChC,wBAAwB;EACxB;4BAC0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kEAAkE;AACpE","sourcesContent":[".health-status {\n  position: relative;\n  display: inline-flex;\n}\n\n.health-status__trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border: 1px solid var(--color-theme-toggle-border);\n  border-radius: 999px;\n  background: var(--color-theme-toggle-bg);\n  color: var(--color-theme-toggle-icon);\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;\n}\n\n.health-status__trigger svg,\n.health-status__trigger .app-icon {\n  width: 18px;\n  height: 18px;\n  color: inherit;\n}\n\n.health-status__trigger:hover,\n.health-status__trigger--open {\n  background: var(--color-theme-toggle-hover);\n  color: var(--color-text);\n}\n\n.health-status__popup {\n  position: absolute;\n  top: calc(100% + 0.55rem);\n  right: 0;\n  z-index: 20;\n  width: min(360px, calc(100vw - 1.5rem));\n  max-width: calc(100vw - 1.5rem);\n  padding: 0.85rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n}\n\n@media (max-width: 640px) {\n  .health-status__popup {\n    position: fixed;\n    top: calc(0.65rem + 42px + 0.45rem + env(safe-area-inset-top, 0px));\n    right: max(0.65rem, env(safe-area-inset-right, 0px));\n    left: max(0.65rem, env(safe-area-inset-left, 0px));\n    width: auto;\n    max-width: none;\n  }\n}\n\n.health-status__popup-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.65rem;\n}\n\n.health-status__popup-header strong {\n  display: block;\n  font-size: 0.88rem;\n}\n\n.health-status__popup-header span {\n  display: block;\n  margin-top: 0.1rem;\n  color: var(--color-text-muted);\n  font-size: 0.72rem;\n}\n\n.health-status__refresh {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  border: none;\n  border-radius: 999px;\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n  cursor: pointer;\n  transition: filter 0.2s ease, background 0.2s ease;\n}\n\n.health-status__refresh:hover:not(:disabled) {\n  filter: brightness(1.08);\n}\n\n[data-theme='dark'] .health-status__refresh {\n  background: #ffffff;\n  color: #1a2332;\n}\n\n[data-theme='dark'] .health-status__refresh:hover:not(:disabled) {\n  filter: brightness(0.96);\n}\n\n.health-status__refresh:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.health-status__refresh svg,\n.health-status__refresh .app-icon {\n  width: 16px;\n  height: 16px;\n  color: inherit;\n}\n\n.health-status__json {\n  margin: 0;\n  max-height: 280px;\n  padding: 0.85rem;\n  overflow: auto;\n  border: 1px solid var(--color-border);\n  border-radius: calc(var(--radius) - 2px);\n  background: var(--color-surface);\n  color: var(--color-text);\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',\n    'Courier New', monospace;\n  font-size: 0.78rem;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.health-status__json--error {\n  border-color: color-mix(in srgb, #b42318 40%, var(--color-border));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
